import React from "react";
import { Mail, Phone, Facebook } from "lucide-react";

const LOGO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_bold-davinci-9/artifacts/2e1q3mah_Screenshot%202026-07-24%20at%201.01.30%E2%80%AFPM.png";

const FACEBOOK_URL =
  "https://www.facebook.com/people/Friends-of-Greg-Clark/61591538444437/";

const Footer = () => {
  return (
    <footer className="bg-[#0a3161] text-white">
      <div className="divider-stripe" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="bg-white/5 rounded-xl p-4 inline-block border border-white/10">
              <img
                src={LOGO_URL}
                alt="Greg Clark for 19th District"
                className="h-20 w-auto"
              />
            </div>
            <p className="mt-6 text-white/70 text-sm leading-relaxed max-w-sm">
              Working for Oswego County&rsquo;s future. Together.
            </p>
            <a
              href={FACEBOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#1877F2] hover:bg-[#0f5cbf] transition-colors text-white font-oswald text-sm font-semibold uppercase tracking-[0.14em]"
            >
              <Facebook className="w-4 h-4" />
              Follow on Facebook
            </a>
          </div>

          <div>
            <div className="font-oswald text-xs uppercase tracking-[0.22em] font-semibold text-white/60 mb-4">
              Explore
            </div>
            <ul className="space-y-3 text-sm">
              {[
                ["About", "#about"],
                ["News", "#news"],
                ["Donate", "#donate"],
                ["Contact", "#contact"],
              ].map(([l, h]) => (
                <li key={l}>
                  <a
                    href={h}
                    className="font-oswald uppercase tracking-[0.12em] text-white/80 hover:text-white transition-colors"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-oswald text-xs uppercase tracking-[0.22em] font-semibold text-white/60 mb-4">
              Contact
            </div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#b22234]" />
                <a
                  href="mailto:gregclarkfor19thdistrict@gmail.com"
                  className="text-white/85 hover:text-white break-all"
                >
                  gregclarkfor19thdistrict@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#b22234]" />
                <a
                  href="tel:+13152365975"
                  className="text-white/85 hover:text-white"
                >
                  (315) 236-5975
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col gap-6">
          <div className="flex justify-center">
            <div className="inline-block border-2 border-white/40 rounded-lg px-6 py-3 bg-white/5">
              <div className="font-oswald text-white text-sm md:text-base font-semibold uppercase tracking-[0.18em] text-center">
                Paid for by Friends of Gregory Clark
              </div>
            </div>
          </div>
          <div className="flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/60">
            <div>&copy; {new Date().getFullYear()} Friends of Gregory A. Clark. All rights reserved.</div>
            <div>19th District &middot; Oswego County Legislature</div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
